var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.4343 13.7317L0.234305 8.53172C-0.0781016 8.21932 -0.0781016 7.71279 0.234305 7.40035L1.36565 6.26897C1.67805 5.95653 2.18462 5.95653 2.49702 6.26897L5.99999 9.77191L13.503 2.26897C13.8154 1.95657 14.3219 1.95657 14.6343 2.26897L15.7657 3.40035C16.0781 3.71275 16.0781 4.21929 15.7657 4.53172L6.56568 13.7318C6.25324 14.0442 5.74671 14.0442 5.4343 13.7317Z",
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckGrey);
export default __webpack_public_path__ + "static/media/checkGrey.3c26c3341e89d994b2eaf0b531f74c00.svg";
export { ForwardRef as ReactComponent };